<div class="position-relative d-flex p-3 p-md-5 m-md-3 text-center bg-dark intro-banner">
  <div class="col-md-8 p-lg-5 mx-auto text-white align-self-center">
    <h1 class="display-5 font-weight-bold mx-auto">{{'Construction' | translate}}</h1>
  </div>
</div>
<contact-us-btn></contact-us-btn>
<hr class="mb-5 mt-3">
<div class="container">
    <div class="text-center my-5 mb-5">
        <h2 class="title sub-bar">{{'Analyse du secteur de la Construction / du BTP' | translate}}</h2>
    </div>
    <div class="container justif-center my-5">
      <p><span class="bold-blue">{{ 'L’industrie de la construction' | translate}}</span> {{ 'désigne la branche de' | translate}} <span class="bold">{{ 'l’industrie manufacturière' | translate}}</span> {{ 'basée sur la construction, l’entretien et la réparation de structures, y compris tous les entrepreneurs généraux et les constructeurs opérationnels dont l’activité principale est la construction de bâtiments résidentiels, agricoles, industriels, commerciaux ou autres.' | translate}}</p>
    </div>
</div>
<div class="block-free-access py-5">
    <div class="container px-5">
        <div class="block p-0">
            <ul class="nav landing-tabs" id="myTab" role="tablist">
                <li class="nav-item">
                    <a class="nav-link active" id="global-tab" data-toggle="tab" href="#global" role="tab" aria-controls="global" aria-selected="true" title="World">
                        <div class="icon">
                          <picture>
            									<source srcset="/assets/world_icon.webp" type="image/webp">
                              <source srcset="/assets/world_icon.png" type="image/png">
            									<img src="/assets/world_icon.png" class="pays" alt="Global construction sector trends: Accidentology and Market Analysis" title="World" loading="lazy"/>
            							</picture>
                        </div>
                        <b class="text-uppercase">{{'Global' | translate}}</b>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="usa-tab" data-toggle="tab" href="#usa" role="tab" aria-controls="usa" aria-selected="false" title="USA">
                        <div class="icon">
                          <picture>
            									<source srcset="/assets/usa_icon.webp" type="image/webp">
                              <source srcset="/assets/usa_icon.png" type="image/png">
            									<img src="/assets/usa_icon.png" class="pays" alt="United States construction sector trends: Accidentology and Market Analysis" title="USA" loading="lazy"/>
            							</picture>
                        </div>
                        <b class="text-uppercase">{{'Etats-Unis' | translate}}</b>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="france-tab" data-toggle="tab" href="#france" role="tab" aria-controls="france" aria-selected="false" title="France">
                        <div class="icon">
                          <picture>
            									<source srcset="/assets/france_icon.webp" type="image/webp">
                              <source srcset="/assets/france_icon.png" type="image/png">
            									<img src="/assets/france_icon.png" class="pays" alt="French construction sector trends: Accidentology and Market Analysis" title="France" loading="lazy"/>
            							</picture>
                        </div>
                        <b class="text-uppercase">{{'France' | translate}}</b>
                    </a>
                </li>
            </ul>
            <hr class="my-0">
            <div class="tab-content text-center py-4 px-3 px-md-5" id="myTabContent">
                <div class="tab-pane fade show active" id="global" role="tabpanel" aria-labelledby="global-tab">
                    <b class="sub-bar">{{'GLOBAL' | translate}}</b>
                    <p class="mb-0 mt-4 sub-title"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'ACCIDENTS :' | translate}}</p>
                    <ul class="mb-0 mt-2 text-justify">
                      <li>{{'L’Organisation internationale du travail (OIT) estime qu’au moins 60 000 accidents mortels se produisent chaque année sur les chantiers de construction dans le monde.' | translate}} <a class="source" href="https://www.ilo.org/global/about-the-ilo/newsroom/news/WCMS_005161/lang--en/index.htm" target="_blank" rel="noopener nofollow" title="ILO">{{'(source)' | translate}}</a></li>
                      <li>{{'Cela signifie qu’il y a un accident mortel toutes les 10 minutes dans le monde.' | translate}} <a class="source" href="https://www.ilo.org/global/about-the-ilo/newsroom/news/WCMS_005161/lang--en/index.htm" target="_blank" rel="noopener nofollow" title="ILO">{{'(source)' | translate}}</a></li>
                    </ul>
                    <p class="mb-0 mt-4 sub-title"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'MARCHÉ :' | translate}}</p>
                    <ul class="mb-0 mt-2 text-justify">
                      <li>{{'Le secteur mondial de la construction devrait connaître un TCAC de 6,5 % et atteindre 10 835 600 milliards de dollars d’ici 2023.' | translate}} <a class="source" href="https://www.globenewswire.com/news-release/2020/01/02/1965613/0/en/World-Construction-Industry-Size-Forecast-to-2023-Continuous-Major-Economic-Growth-in-Various-Developed-Emerging-Markets-Drives-the-Industry.html" target="_blank" rel="noopener nofollow" title="globenewswire">{{'(source)' | translate}}</a></li>
                    </ul>
                </div>
                <div class="tab-pane fade" id="usa" role="tabpanel" aria-labelledby="usa-tab">
                  <b class="sub-bar">{{'ETATS-UNIS' | translate}}</b>
                  <p class="mb-0 mt-4 sub-title"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'ACCIDENTS :' | translate}}</p>
                  <ul class="mb-0 mt-2 text-justify">
                    <li>{{'Aux États-Unis, les travailleurs âgés de 25 à 34 ans sont les plus susceptibles d’être blessés dans un accident de chantier.' | translate}} <a class="source" href="https://www.bigrentz.com/blog/construction-safety-statistics" target="_blank" rel="noopener nofollow" title="bigrentz">{{'(source)' | translate}}</a></li>
                    <li>{{'L’OSHA signale également que les risques de chute sont la principale cause de blessures sur les chantiers de construction.' | translate}} <a class="source" href="https://www.osha.gov/stop-falls" target="_blank" rel="noopener nofollow" title="osha">{{'(source)' | translate}}</a></li>
                  </ul>
                  <p class="mb-0 mt-4 sub-title"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'MARCHÉ :' | translate}}</p>
                  <ul class="mb-0 mt-2 text-justify">
                    <li>{{'Le secteur de la construction aux États-Unis crée chaque année environ 1 000 milliards de dollars de structures et d’infrastructures.' | translate}} <a class="source" href="https://www.agc.org/learn/construction-data" target="_blank" rel="noopener nofollow" title="agc">{{'(source)' | translate}}</a></li>
                  </ul>
                </div>
                <div class="tab-pane fade" id="france" role="tabpanel" aria-labelledby="france-tab">
                  <b class="sub-bar">{{'FRANCE' | translate}}</b>
                  <p class="mb-0 mt-4 sub-title"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'ACCIDENTS :' | translate}}</p>
                  <ul class="mb-0 mt-2 text-justify">
                    <li>{{'En 2018 en France, il s’est produit 1 accident du travail toutes les 2 minutes.' | translate}} <a class="source" href="https://www.ameli.fr/entreprise/sante-travail/votre-secteur/batiment-travaux-publics/chiffres-cles" target="_blank" rel="noopener nofollow" title="ameli">{{'(source)' | translate}}</a></li>
                    <li>{{'En 2018 en France, le secteur a connu +1,9% des accidents du travail.' | translate}} <a class="source" href="https://www.editions-tissot.fr/actualite/droit-du-travail/accidents-du-travail-dans-le-btp-des-chiffres-en-hausse" target="_blank" rel="noopener nofollow" title="editions-tissot">{{'(source)' | translate}}</a></li>
                  </ul>
                  <p class="mb-0 mt-4 sub-title"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'MARCHÉ :' | translate}}</p>
                  <ul class="mb-0 mt-2 text-justify">
                    <li>{{'Le marché français de la construction représente un chiffre d’affaires total de 175 milliards d’euros, avec plus de 1,4 million de salariés et 536 000 entreprises' | translate}} <a class="source" href="https://www.idelecplus.com/actualite-du-batiment" target="_blank" rel="noopener nofollow" title="idelecplus">{{'(source)' | translate}}</a></li>
                  </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container my-5">
    <div class="text-center mb-5">
        <h2 class="title sub-bar">{{'Challenges du secteur' | translate}}</h2>
    </div>
    <div class="row pt-4">
        <div class="col-12 col-md-6 px-4 pt-4 mb-md-4 mb-4 d-flex justify-content-center align-items-center">
            <div>
                <p class="challenge"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'Défi n°1 :' | translate}}</p>
                <p class="text-justify">{{'Charge de travail importante afin de rester à jour sur les législations du secteur et les règlementations liées au COVID' | translate}}</p>
                <div class="vertical-line">
                  <p class="font-weight-bold ifsolution">{{'Comment la solution d’Immersive Factory aide à surmonter ce défi :' | translate}}</p>
                  {{'Plateforme clé en main qui vous décharge/fait gagner du temps sur les aspects d’organisation de journées sécurité, ' | translate }} <a class="source" [routerLink]="language.navigateAccordingToLang(['/blog/131-Quart-dheure-sécurité-les-avantages-de-limmersive-learning'])" target="_blank" rel="noopener nofollow" title="15-minute safety meetings">{{'quarts d’heures sécurité' | translate}}</a>{{', de formations, etc. qui vous laisse le temps pour vous consacrer à d’autres sujets importants tels qu’être à jour sur les réglementations du secteur.' | translate}}
                </div>
            </div>
        </div>
        <div class="col-12 col-md-6 mb-md-0 px-4 mb-md-4 mb-4">
            <picture>
                <source srcset="assets/campus.webp" type="image/webp">
                <source srcset="assets/campus.jpg" type="image/jpg">
                <img src="assets/campus.jpg" class="block-rounded abstract-formation" alt="Immersive Factory Virtual Campus" title="Virtual Campus" loading="lazy"/>
            </picture>
        </div>
    </div>
    <hr class="px-2 mb-4">
    <div class="row pt-4">
        <div class="col-12 col-md-6 mb-md-0 px-4 mb-md-4 mb-4">
            <picture>
                <source srcset="assets/femme_VR.webp" type="image/webp">
                <source srcset="assets/femme_VR.jpg" type="image/jpg">
                <img src="assets/femme_VR.jpg" class="block-rounded abstract-formation" alt="A woman using a VR headset to train for EHS risks" title="Immersive VR training" loading="lazy"/>
            </picture>
        </div>
        <div class="col-12 col-md-6 px-4 pt-4 mb-md-4 mb-4 d-flex justify-content-center align-items-center">
            <div>
                <p class="challenge"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'Défi n°2 :' | translate}}</p>
                <p class="text-justify">{{'Nécessité de faire des formations innovantes, efficaces et engageantes pour les employés pour effectivement réduire les accidents de travail' | translate}}</p>
                <div class="vertical-line">
                  <p class="font-weight-bold ifsolution">{{'Comment la solution d’Immersive Factory aide à surmonter ce défi :' | translate}}</p>
                  {{'Plateforme digitale immersive 3D & VR avec un catalogue de plus de 30 exercices en apprentissage immersif permettant un apprentissage plus rapide et plus efficace que les formations classiques pour réduire efficacement le nombre d’accidents.' | translate}}
                </div>
            </div>
        </div>
    </div>
    <hr class="px-2 my-4">
    <div class="row pt-4">
        <div class="col-12 col-md-6 px-4 pt-4 mb-md-4 mb-4 d-flex justify-content-center align-items-center">
            <div>
                <p class="challenge"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'Défi n°3 :' | translate}}</p>
                <p class="text-justify">{{'Volonté de créer une culture de la sécurité dans le secteur, motivé par le nombre d’accidents élevé de celui-ci' | translate}}</p>
                <div class="vertical-line">
                  <p class="font-weight-bold ifsolution">{{'Comment la solution d’Immersive Factory aide à surmonter ce défi :' | translate}}</p>
                  {{'Adoption d’une solution innovante pour avoir une longueur d’avance sur la compétition tout en contribuant à la mise en place d’une culture de la sécurité dans l’industrie grâce à un outil facile à déployer.' | translate}}
                </div>
            </div>
        </div>
        <div class="col-12 col-md-6 mb-md-0 px-4 mb-md-4 mb-4">
            <picture>
                <source srcset="assets/new_training_room.webp" type="image/webp">
                <source srcset="assets/new_training_room.jpg" type="image/jpg">
                <img src="assets/new_training_room.jpg" class="block-rounded abstract-formation" alt="Immersive Factory Virtual Campus Training Room" title="Training room" loading="lazy"/>
            </picture>
        </div>
    </div>
    <hr class="px-2 my-4">
    <div class="row pt-4">
        <div class="col-12 col-md-6 mb-md-0 px-4 mb-md-4 mb-4">
            <picture>
                <source srcset="assets/Reporting_Moyenne_Horizontal_V2.webp" type="image/webp">
                <source srcset="assets/Reporting_Moyenne_Horizontal_V2.jpg" type="image/jpg">
                <img src="assets/Reporting_Moyenne_Horizontal_V2.jpg" class="block-rounded abstract-formation" alt="Website backoffice: reporting and statistics" title="Reporting and statistics" loading="lazy"/>
            </picture>
        </div>
        <div class="col-12 col-md-6 px-4 pt-4 mb-md-4 mb-4 d-flex justify-content-center align-items-center">
            <div>
                <p class="challenge"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'Défi n°4 :' | translate}}</p>
                <p class="text-justify">{{'Difficulté du mode de formation pour le personnel et les équipes mobiles, car l’on fait face à un nouvel environnement pour chaque lieu : très dépendant du site de construction du client ce qui demande une organisation particulière' | translate}}</p>
                <div class="vertical-line">
                  <p class="font-weight-bold ifsolution">{{'Comment la solution d’Immersive Factory aide à surmonter ce défi :' | translate}}</p>
                  {{'Outil personnalisable permettant la cohérence des actions de chaque site sur un outil unique, et multi-device permettant à chaque apprenant de s’entraîner en sécurité, où qu’il se trouve. Le back office intuitif et l’accès des données en temps réel sur les indicateurs clés de performance (KPI) permet un suivi des efforts et des réalisations des équipes constant.' | translate}}
                </div>
            </div>
        </div>
    </div>
    <hr class="px-2 my-4">
    <div class="row pt-4">
        <div class="col-12 col-md-6 px-4 pt-4 mb-md-4 mb-4 d-flex justify-content-center align-items-center">
            <div>
                <p class="challenge"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'Défi n°5 :' | translate}}</p>
                <p class="text-justify">{{'Besoin d’engager et de re-motiver le personnel pendant l’accueil sécurité, car il peut être ennuyeux (papier et stylo) et prend beaucoup de temps en terme d’organisation' | translate}}</p>
                <div class="vertical-line">
                  <p class="font-weight-bold ifsolution">{{'Comment la solution d’Immersive Factory aide à surmonter ce défi :' | translate}}</p>
                  {{'Solution innovante, originale mettant en œuvre la gamification & ludopédagogie afin de re-motiver et ré-engager les employés, les rendant ainsi plus heureux tout en s’assurant de leur sécurité.' | translate}}
                </div>
            </div>
        </div>
        <div class="col-12 col-md-6 mb-md-0 px-4 mb-md-4 mb-4">
            <picture>
                <source srcset="assets/Formation_Interactive.webp" type="image/webp">
                <source srcset="assets/Formation_Interactive.jpg" type="image/jpg">
                <img src="assets/Formation_Interactive.jpg" class="block-rounded abstract-formation" alt="A man using a VR headset to raise awareness of EHS risks that can occur in a warehouse" title="EHS VR training" loading="lazy"/>
            </picture>
        </div>
    </div>
    <hr class="px-2 my-4">
    <div class="row pt-4">
        <div class="col-12 col-md-6 mb-md-0 px-4 mb-md-4 mb-4">
            <picture>
                <source srcset="assets/multi_supports.webp" type="image/webp">
                <source srcset="assets/multi_supports.jpg" type="image/jpg">
                <img src="assets/multi_supports.jpg" class="block-rounded abstract-formation" alt="Immersive Factory virtual campus is available on PC and Mac" title="Multi-support" loading="lazy"/>
            </picture>
        </div>
        <div class="col-12 col-md-6 px-4 pt-4 mb-md-4 mb-4 d-flex justify-content-center align-items-center">
            <div>
                <p class="challenge"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'Défi n°6 :' | translate}}</p>
                <p class="text-justify">{{'Problème d’accessibilité : barrière de la langue, difficulté de lecture, d’équipement, etc.' | translate}}</p>
                <div class="vertical-line">
                  <p class="font-weight-bold ifsolution">{{'Comment la solution d’Immersive Factory aide à surmonter ce défi :' | translate}}</p>
                  {{'Plateforme digitale disponible en plusieurs langues et en multi-device pour une utilisation chez soi ou sur site : Everyone, Everywhere, Everyday.' | translate}}
                </div>
            </div>
        </div>
    </div>
</div>
<hr class="my-4">
<div class="container my-5">
    <div class="text-center mb-5">
        <h2 class="title sub-bar">{{'Pourquoi choisir Immersive Factory ?' | translate}}</h2>
    </div>
    <div class="text-justify">
    	<p>{{"Immersive Factory met en place des modules en réalité virtuelle pour permettre la formation à la sécurité, des professionnels du milieu BTP et la maitrise des bons gestes pour éviter les accidents sur les chantiers." | translate}}</p>
    	<p>{{"Nos formations permettent la sensibilisation régulière aux dangers dans le milieu de la construction, et la réduction considérable des accidents. Mettre en place un système d’éducation des collaborateurs aux différents risques en utilisant une plateforme d’eLearning facilite l’apprentissage et permet de simplifier la prévention grâce à des formations en ligne pouvant être visionnées plusieurs fois et à leur rythme, et impliquant directement la participation de vos collaborateurs." | translate }}</p>
    	<p class="mb-0">{{"La prévention des risques en utilisant le système de formation d’Immersive Factory vous permet de protéger la santé de vos employés, respecter les réglementations en vigueur mais aussi d’augmenter les compétences de vos collaborateurs en termes de gestes, postures, et comportements à adopter pour assurer leur sécurité." | translate }}</p>
    </div>
</div>
<hr *ngIf="blocnews" class="my-4">
<div *ngIf="blocnews" class="container">
    <div class="text-center my-5 mb-5">
        <h2 class="title sub-bar">{{'Envie de savoir comment dynamiser vos accueils sécurité dans le secteur du BTP ?' | translate}}</h2>
    </div>
    <div class="container my-5">
      <p class="justif-center">{{ 'Venez en savoir plus sur les accueils sécurité dans le secteur du BTP en consultant cet article de blog :' | translate}}</p>
      <div *ngIf="blocnews" class="mt-4">
        <div class="post row pr-0">
            <div class="col-12 col-md-6 mb-md-0 px-0">
                <a *ngIf="blocnews['link']" [routerLink]="language.navigateAccordingToLang([blocnews['link']])" target="blank" rel="noopener nofollow" title="{{blocnews['title']}}"><img src='{{blocnews.imageHeader}}' class="news-image abstract-formation" alt="Boost your safety meetings in the construction industry" title="Work at height VR training" loading="lazy"></a>
            </div>
            <div class="col-12 col-md-6 px-4 pt-4 mb-4 d-flex justify-content-center align-items-center">
                <div>
                    <p *ngIf="blocnews['title']" class="font-weight-bold ifsolution">{{blocnews["title"]}}</p>
                    <div class="informations my-3">
                        <span *ngIf="blocnews['createdDate']" class="date">{{blocnews["createdDate"]}}</span>
                        <div *ngIf="blocnews.tag['title']" class="tag rounded px-2">{{blocnews.tag["title"]}}</div>
                    </div>
                    <div class="actu-body">
                      <p *ngIf="blocnews['shortDesc']" class="description" [innerHTML]="blocnews['shortDesc']"></p>
                      <a *ngIf="blocnews['link']" [routerLink]="language.navigateAccordingToLang([blocnews['link']])" class="viewmore mb-3" target="blank" rel="noopener nofollow" title="{{blocnews['title']}}">{{'Voir plus' | translate}}</a>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
</div>


<hr class="mt-5">
<div class="reassurance">
    <div class="container py-4 mb-4">
        <h3 class="my-4">{{ 'Ils nous font confiance' | translate}}</h3>
        <owl-carousel
            [options]="{
                items: 5,
                dots: false,
                nav: true,
                margin:0,
                loop:true,
                autoplay:true,
                autoplayTimeout:3000,
                autoplayHoverPause:true,
                responsive:{
                    '300':{
                        items:1,
                        nav:true
                    },
                    '768':{
                        items:3,
                        nav:true
                    },
                    '992':{
                        items:5,
                        nav:true,
                        loop:true
                    }
                }
            }"
            [carouselClasses]="['owl-carousel']">
            <div class="logos-theytrustus" *ngFor="let image of images;let i = index">
                <picture>
                    <source srcset="{{image.url}}.webp" type="image/webp">
                    <source srcset="{{image.url}}.png" type="image/png">
                    <img src="{{image.url}}.png" [attr.alt]="image.alt" [attr.title]="image.title" loading="lazy"/>
                </picture>
            </div>
        </owl-carousel>
    </div>
</div>
<hr class="my-4">


<div class="container mb-5">
    <div class="text-center my-5 mb-5">
        <h2 class="title sub-bar">{{'exercices dédiés au secteur de la construction' | translate}}</h2>
    </div>
    <div *ngIf="listProducts" class="mt-4">
        <div class="row ml-0 mr-0">
          <app-product-card class="col-md-4 mt-4"  *ngFor="let product of listProducts" [product]="product"></app-product-card>
        </div>
    </div>
</div>
<!-- TEMOIGNAGE CLIENT
<hr class="my-4">
<div class="container">
    <div class="text-center my-5 mb-5">
        <span class="title sub-bar">{{'Témoignage client' | translate}}</span>
    </div>

    <div class="container-fluid mb-5">
        <div class="row">
            <div class="col-md-6 col-12 latest-pub">
                <h2 class="title-pub bold px-4 pt-2">{{'Téléchargez notre dernier témoignage client' | translate}}</h2>
                <h3 class="text-pub mt-2 px-4">{{'Témoignage Lorem Ipsum' | translate}}</h3>
                <a href="https://communication.immersivefactory.com/{{'FR_Analyse_Critique_Modeles_Apprentissage.pdf' | translate}}" target="_blank">
                <div class="download-btn mt-4">
                    <i class="fas fa-download"></i><span class="ml-2">{{'Télécharger' | translate}}</span>
                </div>
                </a>
            </div>
            <div class="col-md-6 col-12 book">
                <div class="magasine magasine-{{language.lang}}">
                </div>
            </div>
        </div>
    </div>
</div>
-->
